/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:mentor
 */

import * as Types from '../../types/mentor-gql';

import { api } from 'app/apis/mentor-gql-api';
export type MentorDash_MentorQueryQueryVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
}>;

export type MentorDash_MentorQueryQuery = {
  __typename?: 'Query';
  mentor?: {
    __typename?: 'Mentor';
    uid: string;
    country?: string | null;
    languages?: Array<string | null> | null;
    approved_languages?: Array<string | null> | null;
    bio?: string | null;
    github_url?: string | null;
    linkedin_url?: string | null;
    avatar_url?: string | null;
    application?: any | null;
    agrees_terms_of_service?: boolean | null;
    agreement_version?: string | null;
    payoneer_status?: string | null;
    phone_number?: string | null;
    available_hours?: number | null;
    timezone?: string | null;
    blocked?: boolean | null;
    gig_approved?: boolean | null;
    gov_mentor_agreement_version?: string | null;
    services?: {
      __typename?: 'Services';
      classroom_mentorship?: boolean | null;
      connect?: boolean | null;
      reviews?: boolean | null;
      community?: boolean | null;
      government_mentorship?: boolean | null;
    } | null;
  } | null;
};

export const MentorDash_MentorQueryDocument = `
    query MentorDash_MentorQuery($uid: String!) {
  mentor(uid: $uid) {
    uid
    country
    languages
    approved_languages
    bio
    github_url
    linkedin_url
    avatar_url
    application
    agrees_terms_of_service
    agreement_version
    payoneer_status
    phone_number
    available_hours
    timezone
    blocked
    gig_approved
    gov_mentor_agreement_version
    services {
      classroom_mentorship
      connect
      reviews
      community
      government_mentorship
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_MentorQuery: build.query<MentorDash_MentorQueryQuery, MentorDash_MentorQueryQueryVariables>({
      query: (variables) => ({ document: MentorDash_MentorQueryDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
